import { Linkable } from '@/components/blocks/Linkable';
import { useMobileHeaderQuery } from '@/components/content/Header';
import {
	headerMobileBreadcrumbMenuIconSX,
	headerMobileBreadcrumbMenuItemLinkSX,
} from '@/components/content/Header/styles/mobileDrawer';
import { headerNavBarItemSX } from '@/components/content/Header/styles/navBar/item';
import { Box } from '@mui/material';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';

export const DpHeaderTemporalCategory: React.FC<
	React.PropsWithChildren<{
		href: string;
	}>
> = ({ href, children }) => {
	const isMobile = useMobileHeaderQuery();

	if (isMobile) {
		return (
			<Linkable href={href} sx={headerMobileBreadcrumbMenuItemLinkSX}>
				<Box
					sx={{
						pb: { xs: 0, md: 2 },
						pt: { xs: 0, md: 2 },
						position: 'relative',
					}}
				>
					<Box
						sx={{
							textDecoration: 'none',
							color: '#2c2c2c !important',
							textTransform: 'uppercase',
							fontSize: '16px',
							fontFamily: 'Open Sans, Helvetica Neue, Arial, sans-serif',
							fontWeight: 600,
							position: 'relative',
							whiteSpace: 'nowrap',
							transition: 'color 0.3s ease',
							'@media (max-width: 1333px)': {
								fontSize: '18px !important',
								fontWeight: 900,
							},
						}}
					>
						{children}
					</Box>
				</Box>
				<ArrowForwardIosIcon sx={headerMobileBreadcrumbMenuIconSX} />
			</Linkable>
		);
	}

	return (
		<Box
			sx={{
				zIndex: 1301,
			}}
		>
			<Linkable href={href} type="button" sx={headerNavBarItemSX}>
				{children}
			</Linkable>
		</Box>
	);
};
